import { Box, Divider, Typography } from "@mui/material";
import { AudioSettingsPanel } from "src/components/common/AudioSettings";
import { useContactCenterTheme } from "../../theming/ContactCenterThemeContext";
import { ThemePicker } from "../../theming/ThemePicker";
import AudioSettings from "./AudioSettings";

export default function SettingViewMobile() {
  const { theme } = useContactCenterTheme();

  return (
    <Box
      sx={{
        width: "100%",
        overflowY: "auto",
        height: "100%",
        backgroundColor: theme.shell.bg,
      }}
    >
      <Box sx={{ px: 2, pt: 1.5, pb: 1.75 }}>
        <Typography
          sx={{
            fontSize: "0.65rem",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            color: theme.shell.textSecondary,
            mb: 0.5,
          }}
        >
          Appearance
        </Typography>

        <Typography sx={{ fontSize: "0.72rem", color: theme.shell.textSecondary, mb: 1.5 }}>
          Pick a theme for your chats, notifications and chat windows.
        </Typography>

        <ThemePicker />
      </Box>

      <Divider sx={{ mx: 2, borderColor: theme.shell.border }} />

      {/* Esto es para los tonos */}
      <AudioSettingsPanel channels={["call", "message"]} />

      {/* Esto es el microfono */}
      <AudioSettings />
    </Box>
  );
}
